<script setup lang="ts">
  import { fmt } from '@/functions'
  import { useRefreshBalance } from '@/models/app'
  import { useAppStore } from '@/stores/app'

  const app = useAppStore()

  const { getBalance, loadingBalance } = useRefreshBalance()
</script>

<template>
  <div class="text-center text-primary-950">
    <div class="tracking-wide font-extrabold">
      SALDO
    </div>
    <div v-if="!loadingBalance">
      <span class="text-lg mr-2">Rp</span>
      <span class="font-extrabold text-4xl">{{ fmt.number(app.balance) }}</span>
      <app-button
        class="items-center justify-center rounded-full size-6 bg-gray-100 ml-2 inline-flex"
        @click="getBalance()">
        <fa-icon icon="i-far-rotate-right" />
      </app-button>
    </div>
    <template v-else>
      <span class="font-extrabold text-4xl">Memuat Saldo...</span>
    </template>
  </div>
</template>
